module.exports = __webpack_public_path__ + "assets/search-icon.266d85154e629d6b56d6a0e57c68f4ea.svg";